export default __webpack_public_path__ + "static/media/11-min.47f76381.jpg";